export default __webpack_public_path__ + "static/slide-07-a87645e42de0ec384ceff06f605102b2.png";